<template>
  <FormItem v-bind="itemProps">
    <div class="share-keyword">
      <Select
        :value="value.id"
        filterable
        @input="(id) => inputHandler({ id, isPriority: !!this.value.isPriority })"
        clearable
        v-bind="selectProps"
      >
        <Option v-for="rating in options" :key="rating.label_id" :value="rating.label_id">
          {{`${rating.own !== 0 ? `个性库－` : ''}${rating.industryName}${rating.sceneName? `-${rating.sceneName}` : ''}
          ${rating.label? `-${rating.label}` : ''}${rating.describe? `(描述:${rating.describe})` : ''}`}}
        </Option>
        <Option v-if="!options.some(item => item.label_id === this.value.id)" :value="value.id" :key="value.id">
          {{ value.id }}
        </Option>
      </Select>
      <!-- <i-switch :value="value.isPriority" @on-change="(val) => inputHandler({ id: this.value.id, isPriority: val })" size="large" class="priority-switch">
        <span slot="open">前置</span>
        <span slot="close">后置</span>
      </i-switch> -->
    </div>
  </FormItem>
</template>

<script>
import { mapState } from 'vuex'
import { getSystemIntentA } from '@/server/api'

export default {
  data() {
    return {
      options: [],
    }
  },
  props: {
    value: {
      default: () => ({ id: '', isPriority: true }),
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
    selectProps: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    ...mapState('scene', [
			'industry',
    ]),
    itemProps() {
      return {
        label: '意图词库',
        ...this.formItemProps,
      }
    },
  },
  methods: {
    inputHandler(val) {
      this.$emit('input', val)
    },
    // 获取所有意图词库
    getShareKey() {
      getSystemIntentA({
        industry: this.industry.industry,
        scene: this.industry.scene,
      }).then(res => {
        const { common = [], special = [] } = res.data || {};
        this.options = [...common,...special]
      })
    }
  },
  mounted() {
    this.getShareKey();
  }
}
</script>

<style lang="scss" scoped>
.share-keyword {
  display: flex;
  align-items: center;
}
.priority-switch {
  margin-left: 5px;
}
</style>